export function getValue(obj: any, path: string) {
    return path.split('.').reduce((acc: any, key: string) => (acc ? acc[key] : undefined), obj);
}
